import { render, staticRenderFns } from "./chatEmoji.vue?vue&type=template&id=1370b548&scoped=true&"
import script from "./chatEmoji.vue?vue&type=script&lang=js&"
export * from "./chatEmoji.vue?vue&type=script&lang=js&"
import style0 from "./chatEmoji.vue?vue&type=style&index=0&id=1370b548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370b548",
  null
  
)

export default component.exports